import { Card, Col, Row } from "react-bootstrap";
import { ILicenceTransferDetails } from "../../../api/ILicenceTransfer";
import EpaField2Rows from "../../../leap-components/EpaField2Rows";
import { TransferIcon } from "../../../leap-components/icons/LeapIcons";

interface LicenceTransferHeaderProps {
  licenceTransferDetails: ILicenceTransferDetails;
}

const LicenceTransferHeader = ({
  licenceTransferDetails,
}: LicenceTransferHeaderProps) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header></Card.Header>
      <Card.Body className="pt-0">
        <Row>
          <Col className="col-12 col-md-6">
            <table className="no-border" style={{ marginTop: "0.6rem" }}>
              <tbody>
                <tr>
                  <td>
                    <TransferIcon />
                  </td>
                  <td>
                    <h2>
                      Transfer Request: {licenceTransferDetails.casenumber}
                    </h2>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-md-none" style={{ height: "20px" }}></div>
          </Col>
          <Col className="col-6 col-md-3">
            <EpaField2Rows
              label={"Status"}
              value={licenceTransferDetails.status}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default LicenceTransferHeader;
